import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { apiParameters } from 'src/app/configs/api.params';
import { IFilialAdmin } from '../models/filial.model';

@Injectable({
  providedIn: 'root',
})
export class FilialAdminService {
  public apiEndPoint = apiParameters.url;

  constructor(private http: HttpClient) {}

  createFilialAdmin(companyId: string, body: any): Observable<IFilialAdmin> {
    return this.http.post<IFilialAdmin>(
      `${apiParameters.url}/companies/${companyId}/filial-admins`,
      body
    );
  }

  getCompanyFilialAdmins(companyId: string): Observable<IFilialAdmin> {
    return this.http.get<IFilialAdmin>(
      `${apiParameters.url}/companies/${companyId}/filial-admins`
    );
  }

  getCompanyFilialAdmin(
    companyId: string,
    filialAdminId: string
  ): Observable<IFilialAdmin> {
    return this.http.get<IFilialAdmin>(
      `${apiParameters.url}/companies/${companyId}/filial-admins/${filialAdminId}`
    );
  }

  assignAdminToFilial(
    companyId: string,
    filialId: string,
    filialAdminIds: string[]
  ): Observable<any> {
    let body = {
      filialAdminIds,
    };
    return this.http.patch(
      `${apiParameters.url}/companies/${companyId}/filials/${filialId}/add-admins`,
      body
    );
  }

  getAdminsAssignToFilial(
    companyId: string,
    filialId: string
  ): Observable<IFilialAdmin> {
    return this.http.get<IFilialAdmin>(
      `${apiParameters.url}/companies/${companyId}/filials/${filialId}/admins`
    );
  }

  removeAdminFromCompanyFilial(
    companyId: string,
    filialId: string,
    filialAdminIds: string[]
  ): Observable<any> {
    let body = {
      filialAdminIds: filialAdminIds,
    };
    return this.http.patch(
      `${apiParameters.url}/companies/${companyId}/filials/${filialId}/remove-admins`,
      body
    );
  }

  deleteCompanyFilialAdmin(
    companyId: string,
    filialAdminId: string
  ): Observable<any> {
    return this.http.delete(
      `${apiParameters.url}/companies/${companyId}/filial-admins/${filialAdminId}`
    );
  }

  getAllFilialsAssignToFilialAdmin(filialAdminId: string): Observable<any> {
    return this.http.get(
      `${apiParameters.url}/filial-admins/${filialAdminId}/filials`
    );
  }

  updateCompanyFilialAdmin(
    companyId: string,
    filialAdminId: string,
    body: any
  ) {
    return this.http.patch(
      `${apiParameters.url}/companies/${companyId}/filial-admins/${filialAdminId}`,
      body
    );
  }
}
